import {Practice} from '../models/Practice';

export function isMessagingEnabled(practice?: Practice | null): boolean {
  return !!practice?.messagingEnabled;
}
